var _defs, _rect, _g, _text, _text2, _text3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenieCover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 800,
    viewBox: "0 0 1200 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0a5a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#124663"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,290)",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-90 10 L0 -80 L90 10 L90 110 L-90 110 Z",
    fill: "none",
    stroke: "#cdeeff",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: 30,
    width: 60,
    height: 80,
    fill: "none",
    stroke: "#cdeeff",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -55,
    y1: 60,
    x2: -55,
    y2: 85,
    stroke: "#6bb8d9",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 60,
    x2: 55,
    y2: 85,
    stroke: "#6bb8d9",
    strokeWidth: 8,
    strokeLinecap: "round"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 520,
    textAnchor: "middle",
    fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
    fontSize: 88,
    fontWeight: 700,
    fill: "#ffffff"
  }, "g&#235;nie")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 575,
    textAnchor: "middle",
    fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
    fontSize: 30,
    fontWeight: 500,
    fill: "#6bb8d9",
    letterSpacing: 2
  }, "HOUSEHOLD INVENTORY APP")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 630,
    textAnchor: "middle",
    fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
    fontSize: 22,
    fill: "#cdeeff",
    letterSpacing: 1
  }, "BETA &#8226; REACT 19 &#8226; TYPESCRIPT &#8226; SUPABASE")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenieCover);
export default __webpack_public_path__ + "static/media/genie-cover.cbd619808500a67df203f5a585903549.svg";
export { ForwardRef as ReactComponent };